import { Grid, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { AnswersProps } from "../../app/models/Answers";

const SubjectAreaData = [
  {
    id: 1,
    subject: "Planning a safe, healthy learning environment",
    initial: "",
    registerInitial: "initial1",
  },
  {
    id: 2,
    subject: "Advancing children's physical and intellectual development",
    initial: "",
    registerInitial: "initial2",
  },
  {
    id: 3,
    subject: "Supporting children's social and emotional development",
    initial: "",
    registerInitial: "initial3",
  },
  {
    id: 4,
    subject: "Building productive relationships with families",
    initial: "",
    registerInitial: "initial4",
  },
  {
    id: 5,
    subject: "Managing an effective program",
    initial: "",
    registerInitial: "initial5",
  },
  {
    id: 6,
    subject: "Maintaining a commitment to professionalism",
    initial: "",
    registerInitial: "initial6",
  },
  {
    id: 7,
    subject: "Observing and recording children's behavior",
    initial: "",
    registerInitial: "initial7",
  },
  {
    id: 8,
    subject: "Understanding principles of child development and learning",
    initial: "",
    registerInitial: "initial8",
  },
];
const EFormTable: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const thisDate = new Date();

  const defaultValues = {
    initial1:
      answersData.find((answer) => answer.systemCodeId === 327)?.answer || "",
    initial2:
      answersData.find((answer) => answer.systemCodeId === 328)?.answer || "",
    initial3:
      answersData.find((answer) => answer.systemCodeId === 329)?.answer || "",
    initial4:
      answersData.find((answer) => answer.systemCodeId === 330)?.answer || "",
    initial5:
      answersData.find((answer) => answer.systemCodeId === 331)?.answer || "",
    initial6:
      answersData.find((answer) => answer.systemCodeId === 332)?.answer || "",
    initial7:
      answersData.find((answer) => answer.systemCodeId === 333)?.answer || "",
    initial8:
      answersData.find((answer) => answer.systemCodeId === 334)?.answer || "",
    signature:
      answersData.find((answer) => answer.systemCodeId === 335)?.answer || "",
    date:
      answersData.find((answer) => answer.systemCodeId === 336)?.answer || "",
  };

  const { register } = useForm({
    defaultValues,
    mode: "onTouched",
  });

  return (
    <Grid container p={2}>
      <Grid
        item
        bgcolor="cdaEDU.main"
        color="white"
        p={0.5}
        mt={2}
        mb={2}
        xs={12}
        display="flex"
        justifyContent="space-between"
      >
        <Typography>CDA® Subject Areas</Typography>
        <Typography>Please initial below</Typography>
      </Grid>
      {SubjectAreaData.map((subj: any, index: number) => (
        <Grid
          key={subj.id}
          item
          container
          bgcolor={index % 2 !== 0 ? "#FBFDF5" : "white"}
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignContent="center"
          m={1}
        >
          <Typography>
            {subj.id}. {subj.subject}
          </Typography>
          <Grid item xs={12} md={1}>
            <TextField
              placeholder="initials"
              inputProps={{
                maxLength: 3,
              }}
              {...register(subj.registerInitial)}
              onChange={(e) => {
                const newValue = e.target.value;
                const systemCodeId = 326 + subj.id;

                onAnswerChange(systemCodeId, newValue);
              }}
            />
          </Grid>
        </Grid>
      ))}
      <Grid item xs={12} m={3}>
        <Typography>
          I attest to the accuracy of the above Statements of Completion: that I
          completed at least 10 clock hours of professional education in each of
          the 8 CDA Subject Areas. I also attest that I have met or exceeded 120
          total clock hours of CDA-related professional education.
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Signature"
          {...register("signature")}
          inputProps={{ maxLength: 70 }}
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 335;

            onAnswerChange(systemCodeId, newValue);
            const systemCodeIdDate = 336;

            /*  Adds signature date once the form is signed */
            onAnswerChange(systemCodeIdDate, thisDate.toDateString());
          }}
          InputProps={{
            inputProps: {
              style: {
                textAlign: "center",
                fontSize: 20,
                fontFamily: "Cedarville Cursive, cursive",
              },
            },
          }}
          fullWidth
        />
        <Typography fontSize={11}>
          **DISCLAIMER:** This signature, entered electronically or by any other
          means, is legally binding and has the same force and effect as a
          handwritten signature. By signing, you acknowledge that you have read,
          understood, and agree to be bound by the terms and conditions,
          agreements, or documents to which this signature is affixed.
        </Typography>
      </Grid>
      <Grid item xs={6} textAlign="center">
        <TextField
          disabled
          variant="filled"
          label="Date"
          {...register("date")}
        />
      </Grid>
    </Grid>
  );
};

export default EFormTable;
